import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 16.876 10.124"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.813 0h-6.75A5.065 5.065 0 0 0 0 5.062a5.065 5.065 0 0 0 5.063 5.062h6.75a5.065 5.065 0 0 0 5.063-5.062A5.065 5.065 0 0 0 11.813 0m0 9h-6.75a3.935 3.935 0 0 1-3.937-3.938 3.934 3.934 0 0 1 3.937-3.938h6.75a3.935 3.935 0 0 1 3.937 3.938A3.934 3.934 0 0 1 11.813 9m-6.75-6.75c-.556 0-1.1.164-1.563.473A2.815 2.815 0 0 0 4.514 7.82a2.815 2.815 0 0 0 3.362-2.758A2.815 2.815 0 0 0 5.063 2.25m0 4.5a1.686 1.686 0 0 1-1.655-2.017 1.68 1.68 0 0 1 1.326-1.326 1.687 1.687 0 1 1 .329 3.343"
    }, null, -1)
  ])))
}
export default { render: render }